module.exports = __webpack_public_path__ + "img/logo4kant.94b05d17.png";